import { sendCalls as viem_sendCalls, } from 'viem/actions';
import { getAction } from '../utils/getAction.js';
import { getConnectorClient, } from './getConnectorClient.js';
/** https://wagmi.sh/core/api/actions/sendCalls */
export async function sendCalls(config, parameters) {
    const { account, chainId, connector, calls, ...rest } = parameters;
    const client = await getConnectorClient(config, {
        account,
        assertChainId: false,
        chainId,
        connector,
    });
    const action = getAction(client, viem_sendCalls, 'sendCalls');
    return action({
        ...rest,
        ...(typeof account !== 'undefined' ? { account } : {}),
        calls,
        chain: chainId ? { id: chainId } : undefined,
    });
}
//# sourceMappingURL=sendCalls.js.map